<script setup>
import { ref } from 'vue';
// Components.
import DialogModal from '../elements/DialogModal';
import CheckboxToggle from '../elements/CheckboxToggle';
// Utils.
import { default as t } from '../../translations/translationStrings';

// Non-reactive data.
const organicFarmingLogo = `/${require('../../../images/organic-farming/organic-farming.svg')}`;

// Data.
const modalOpen = ref(false);
const infoModal = ref(null);

// Model value.
const modelValue = defineModel();
</script>

<template>
  <div class="organic-farming-switch">
    <CheckboxToggle
      v-model="modelValue"
      :icon="organicFarmingLogo"
      @update:modelValue="(value) => (modelValue = value)">
      <!-- Organic farming logo. -->
      <div class="organic-farming-switch__logo"></div>
    </CheckboxToggle>
    <!-- Organic farming info icon (opens modal). -->
    <div
      class="organic-farming-switch__info"
      @click="infoModal.openDialogModal">
      <i class="far fa-info-circle"></i>
    </div>

    <!-- @todo i think transition needs to be added -->
    <!-- check for file history for help -->
    <DialogModal
      v-modal="modalOpen"
      modal-type="organic-farming"
      ref="infoModal">
      <!-- Modal header. -->
      <template #header>
        <h3 v-html="t.modalHeader"></h3>
      </template>
      <!-- Modal content. -->
      <template #content>
        <img :src="organicFarmingLogo" loading="lazy" />
        <p v-html="t.modalContent"></p>
      </template>
    </DialogModal>
  </div>
</template>
